// extracted by mini-css-extract-plugin
module.exports = {"card":"SquareCard_card__RK8wY","cardContent":"SquareCard_cardContent__PdgtC","link":"SquareCard_link__GqFpc"};